module.exports = __webpack_public_path__ + "static/media/website.0cba5ac0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/website.svg
// module id = 923
// module chunks = 0